import { useEffect, useState } from "react";

const ORIENTATION = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
};

export const useDeviceInfo = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);
  const [orientation, setOrientation] = useState(ORIENTATION.PORTRAIT);

  useEffect(() => {
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    const updateDeviceType = () => {
      const userAgent = navigator.userAgent;
      const matchesMobileUA = mobileRegex.test(userAgent);
      const screenIsLarge = window.innerWidth >= 1024 || window.innerHeight >= 1024;
      
      setIsMobile(matchesMobileUA || !screenIsLarge);
      setIsDesktop(!matchesMobileUA && screenIsLarge);
    };

    const handleDisplayOrientation = () => {
      switch (window.orientation) {
        case 0:
        case 180:
          setOrientation(ORIENTATION.PORTRAIT);
          break;
        case 90:
        case -90:
          setOrientation(ORIENTATION.LANDSCAPE);
          break;
        default:
          break;
      }
    };

    updateDeviceType();
    handleDisplayOrientation();

    window.addEventListener("resize", updateDeviceType);
    window.addEventListener("orientationchange", handleDisplayOrientation, true);

    return () => {
      window.removeEventListener("resize", updateDeviceType);
      window.removeEventListener("orientationchange", handleDisplayOrientation, true);
    };
  }, []);

  return { isMobile, isDesktop, orientation };
};
